import {Service, service, inject} from "./di";

import appboy from "@braze/web-sdk";
import getUser = appboy.getUser;
import {LocationService} from "./LocationService";

@service("BrazeSDKService")
export class BrazeSDKService extends Service {
	@inject location: LocationService;

	async init() {
		if (!await this.location.isAllowedCountry()) return;
		try {
			appboy.initialize("5eb5b3c2-8331-47b3-9248-457fd5452502", {
				baseUrl: "https://sdk.iad-01.braze.com"
			});
			appboy.openSession();
		} catch (e) {
			console.log("Didnt init Braze SDK");
			console.log(e);
		}
	}
	
	async setUser(userId: string, email: string) {
		if (!await this.location.isAllowedCountry()) return;
		appboy.changeUser(userId);
		const user = getUser();
		user.setEmail(email);
	}
}
